module.exports = __webpack_public_path__ + "media/images/common/icon-arrow-right-64c68bf670ba1ed37509242244295682.png";